/* custom JS */

$(function() {   
    
    
    
    $('.template-product .product__description').before('<p class="badges" style="text-align: center;"><img src="https://cdn.shopify.com/s/files/1/2022/7045/files/eleder_usp_2026-07-21.png?v=1784632114" /></p>');
    
    if (window.location.href.indexOf('handyhuelle') >= 0) {
        $('.template-product .badges').after('<p style="color: black; text-align: center;">Die Fotos sind nur illustrativ – die Hülle passt exakt auf das gewählte Telefonmodell.</p>');
        $('.template-product .badges').after('<p style="color: red; text-align: center;">Die Lieferzeit beträgt aufgrund der Herstellung ca. 2-3 Wochen ab Bestelldatum.</p>');
    }
});
